import { Component, OnInit } from '@angular/core';
import { CommonDataStorage } from 'src/app/commondata-storage.service';
import { UserData } from 'src/app/Models/employee-and-user-data';

@Component({
  selector: 'app-ship-name',
  templateUrl: './ship-name.component.html',
  styleUrls: ['./ship-name.component.css'],
})
export class ShipNameComponent implements OnInit {
  userdata?: UserData;
  shipname = '';
  constructor() {
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.shipname = this.userdata?.ShipName!;
  }
  ngOnInit() {}

}
